import {
	TssModeEnum,
	TssModeWithSubTypeEnum
}                             from '@app/modules/tss/models/tss.model';
import { UsageTssTypeEnum }   from '@app/modules/usage/models/fiskal-usage.model';
import { IBrandConfig }       from '@brand/configs/brand.config.interface';
import { BrandEnum }          from '@core/services/brand/brand.enums';
import { environment }        from '@env/environment';
import { EnvironmentEnum }    from '@env/environment.model';
import { ChartColorTypeEnum } from '@shared/overview/overview.model';


const createDocumentationPortalUrl = (): string => {
	const documentationPortalAdditionalSubdomainsMap: { [ key in EnvironmentEnum ]: string } = {
		[ EnvironmentEnum.STABLE ]: "",
		[ EnvironmentEnum.STAGING ]: "staging.gwc.",
		[ EnvironmentEnum.UNSTABLE ]: "unstable.gwc."
	};
	const additionalSubdomains: string =
		documentationPortalAdditionalSubdomainsMap[ environment.activeEnvironment ] ?? "";
	return `https://documentation.${ additionalSubdomains }fiskal.cloud`;
}

const supportPortalUrl = 'https://support.deutsche-fiskal.de';
const documentationPortalUrl: string = createDocumentationPortalUrl();


export const brandConfig: IBrandConfig = {
	activeBranding: BrandEnum.DeutscheFiskal,
	appTitle: 'Fiskal Cloud Portal',
	availableTssModes: [
		TssModeEnum.CLOUD,
		TssModeEnum.TOKEN,
		TssModeEnum.OFFLINE,
		TssModeEnum.SWISSBIT_TOKEN
	],
	availableTssModesWithSubtype: [
		TssModeWithSubTypeEnum.CLOUD,
		TssModeWithSubTypeEnum.TOKEN,
		TssModeWithSubTypeEnum.TOKEN_CV1,
		TssModeWithSubTypeEnum.TOKEN_CV2,
		TssModeWithSubTypeEnum.OFFLINE,
		TssModeWithSubTypeEnum.SWISSBIT_TOKEN
	],
	availableUsageTssTypes: [
		// order matters here (determines the order of appearance on the usage page)
		UsageTssTypeEnum.CLOUD,
		UsageTssTypeEnum.CLOUD_FCC_DC,
		UsageTssTypeEnum.TOKEN,
		UsageTssTypeEnum.SWISSBIT_TOKEN,
		UsageTssTypeEnum.OFFLINE,
		UsageTssTypeEnum.EXT_ERS
	],
	chartColors: {
		[ ChartColorTypeEnum.SIGNATURES ]: [ '#59D4BA', '#FFCA58', '#FF8A43' ],
		[ ChartColorTypeEnum.STATUS ]: [ '#3CC9D4', '#72E5CE', '#FFCA58', '#FF8A43' ],
		[ ChartColorTypeEnum.TENANT ]: [ '#59A0D6', '#59D4BA', '#AAE197', '#FFCA58', '#FF9B43', '#F16143', '#EF57A8', '#BD92E3' ],
		[ ChartColorTypeEnum.TSS_MODE ]: [ '#3CC9D4', '#72E5CE', '#FFCA58', '#FF8A43' ]
	},
	dashboardPage: {
		showIntroductionText: false,
		statusPageLink: 'https://deutschefiskal.statuspage.io',
		supportPortalLink: supportPortalUrl
	},
	entityErrorDataIntegrity: {
		documentationPortalLink: `${ documentationPortalUrl }/md/fiskal_cloud_eric/fiskal_cloud_eric/#data-integrity`
	},
	logoutUrl: `${ window.location.origin }/api/management-ui`,
	sidebar: {
		privacyLink: 'https://www.deutsche-fiskal.de/datenschutz',
		legalNoticesLink: 'https://www.deutsche-fiskal.de/impressum',
		copyrightLink: 'https://www.deutsche-fiskal.de/'
	},
	supportFccDataCenter: true,
	taskCenter: {
		fccOpenTransactionsTask: {
			documentationPortalLink: `${ documentationPortalUrl }/md/fiskal_cloud_administration/fiskal_cloud_task_center/#open-transactions`
		},
		fccVersionsDeveloperPortalLink: `${ documentationPortalUrl }/md/downloads/fcc_downloads/`,
		fiskalTssLogsTask: {
			documentationPortalLink: `${ documentationPortalUrl }/md/fiskal_cloud_archiving/fiskal_cloud_archiving/`,
			supportMailLink: 'info@deutsche-fiskal.de',
			supportPortalLink: supportPortalUrl
		}
	},
	taxationReporting: {
		supportPortalLink: supportPortalUrl
	},
	tenantConsolePage: {
		documentationPortalLink: documentationPortalUrl
	},
	tssLifecycleModal: {
		documentationPortalLink: documentationPortalUrl
	}
};
